<template>
  <div>
    <!-- <h6 class="mb-2">اختر إحدى الطرق التالية :</h6> -->

    <b-row>
      <b-col lg="4" sm="12" v-if="checkMethodAvailability('SYRIATEL')">
        <b-card
          @click="openPaymentModal('SYRIATEL')"
          :img-src="require('@/assets/images/payment-methods/syriatel.png')"
          img-alt="syriatel-cash-logo"
          tag="article"
          class="payment-card"
          overlay
        >
        </b-card>
      </b-col>
      <b-col lg="4" sm="12" v-if="checkMethodAvailability('MTN')">
        <b-card
          @click="openPaymentModal('MTN')"
          style="background-color: #ffc92e"
          :img-src="require('@/assets/images/payment-methods/mtn.png')"
          img-alt="mtn-cash-logo"
          tag="article"
          class="payment-card"
          overlay
        >
        </b-card>
      </b-col>
      <b-col lg="4" sm="12" v-if="checkMethodAvailability('FATORA')">
        <b-card
          @click="fatoraModal = true"
          :img-src="require('@/assets/images/payment-methods/fatora.png')"
          img-alt="fatora-logo"
          tag="article"
          class="payment-card"
          overlay
        >
        </b-card>
      </b-col>

      <cash-modal
        v-model="paymentModal"
        :method.sync="method"
        :methodId.sync="methodId"
      />

      <form-modal
        v-model="fatoraModal"
        :formSchema="fatoraSchema"
        :loading="loadingMethods"
        title="التبرع عن طريق فاتورة"
        static
        @confirm="initFatoraPayment"
      >
        <template #amount="{ form }">
          <form-currency
            v-model="form.amount"
            rules="required"
            label="قيمة المبلغ"
          />
        </template>
      </form-modal>
    </b-row>
  </div>
</template>

<script>
import CashModal from "./CashModal.vue";
import { BCard, BRow, BCol } from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import FormModal from "@/components/FormModal.vue";
import FormCurrency from "@/components/FormCurrency.vue";

export default {
  components: {
    CashModal,
    BCard,
    BRow,
    BCol,
    FormModal,
    FormCurrency,
  },
  data() {
    return {
      paymentModal: false,
      method: null,
      methodId: null,
      fatoraModal: false,
      fatoraSchema: {
        amount: {
          key: "amount",
        },
      },
    };
  },
  computed: {
    ...mapGetters("NgoHome/donationNgo", [
      "loadingMethods",
      "availableMethods",
    ]),
  },
  methods: {
    ...mapActions("NgoHome/donationNgo", [
      "getAvailablePaymentMethods",
      "initFatora",
    ]),
    openPaymentModal(method) {
      this.method = method;
      this.methodId = this.availableMethods.find(
        (e) => e.paymentMethodType.name === method
      ).id;
      this.paymentModal = true;
    },
    initFatoraPayment(form) {
      this.methodId = this.availableMethods.find(
        (e) => e.paymentMethodType.name === "FATORA"
      ).id;
      this.initFatora({ ...form, methodId: this.methodId })
        .then((res) => {
          var newWindow = window.open(
            res.data.data.transaction_url,
            "_blank",
            "top=200,left=900,width=850,height=1100"
          );
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "حدث خطأ أثناء الاتصال ببوابة التبرع",
              icon: "AlertCircleIcon",
              variant: "danger",
              timeout: 6000,
            },
          });
        });
    },
    checkMethodAvailability(method) {
      return this.availableMethods.find(
        (e) => e.paymentMethodType.name === method
      )
        ? true
        : false;
    },
  },

  created() {
    this.getAvailablePaymentMethods(this.$route.params.id);
  },
};
</script>

<style lang="scss">
.payment-card {
  height: 180px;
  .card-img {
    height: 180px;
    object-fit: contain;
  }
  &:hover {
    &.card {
      box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.4);
      cursor: pointer;
    }
  }
  &.card {
    box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.1);
  }
}
</style>
